import { FC } from 'react'
import { getStyledHomeActions, getStyledHomeActionWrapper } from '../../styled-components/HomeSection.styled'
import { Logo } from '../icons/Logo.component'
import { MoreIcon } from '../icons/MoreIcon.component'
import { SearchIcon } from '../icons/SearchIcon.component'

export interface MobileActionsProps {

}

export const MobileActions: FC<MobileActionsProps> = (props) => {

    const StyledHomeActions = getStyledHomeActions()
    const StyledHomeActionsWrapper = getStyledHomeActionWrapper()

    return (
        <StyledHomeActions>
            <Logo color='#FEFEFE' />
            <StyledHomeActionsWrapper>
                <SearchIcon color='#FEFEFE' />
                <MoreIcon color='#FEFEFE' />
            </StyledHomeActionsWrapper>
        </StyledHomeActions>
    )
}